import React from "react";
import DailyPulseModule from "./dailyPulse";
import DailyPulseSagas from "./redux/dailyPulseSagas";
import DailyPulseReducer from "./redux/dailyPulseReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Daily Pulse",
  moduleList: [
    {
      Component: DailyPulseModule,
      moduleName: "dailyPulse",
      saga: DailyPulseSagas(),
      reducer: DailyPulseReducer
    }
  ],
  hideConfigurator: true
};

const DailyPulsePage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default DailyPulsePage;
